var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.5 41.5",
    style: {
      enableBackground: "new 0 0 41.5 41.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D66FF;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.75,
    cy: 20.75,
    r: 20.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.2,12.04c0-0.39-0.22-0.74-0.57-0.9c-0.35-0.16-0.76-0.11-1.05,0.14L18.22,15l5.98,5.98V12.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.88,16.14l-3.89-4.03c-0.37-0.38-0.98-0.39-1.36-0.02c-0.38,0.37-0.39,0.98-0.02,1.36l3.2,3.32h-2.76 c-0.63,0-1.14,0.51-1.14,1.14v5.58c0,0.63,0.51,1.14,1.14,1.14h4.46l6.05,5.46c0.19,0.17,0.42,0.25,0.66,0.25 c0.14,0,0.27-0.03,0.4-0.09c0.36-0.16,0.59-0.51,0.59-0.9v-5.89L16.88,16.14L16.88,16.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.97,23.01c-0.01-0.01-0.01-0.02-0.02-0.03l-2.25-2.14l2.31-2.2c0.09-0.09,0.16-0.19,0.2-0.3l0.1-0.09 c0.17-0.17,0.27-0.39,0.27-0.63c0-0.24-0.1-0.47-0.27-0.63l-2.59-2.47l2.29-2.18c0.35-0.33,0.36-0.89,0.03-1.24 c-0.33-0.35-0.89-0.36-1.24-0.03l-2.98,2.84c-0.17,0.17-0.27,0.39-0.27,0.63c0,0.24,0.1,0.47,0.27,0.63l2.59,2.46l-2.29,2.18 c-0.09,0.09-0.16,0.19-0.2,0.3l-0.1,0.09c-0.17,0.17-0.27,0.39-0.27,0.63c0,0.24,0.1,0.47,0.27,0.63l0.34,0.32 c0.01,0.01,0.01,0.02,0.02,0.03l2.21,2.11l-2.58,2.46c-0.17,0.17-0.27,0.39-0.27,0.63c0,0.24,0.1,0.47,0.27,0.63l2.92,2.78 c0.17,0.16,0.39,0.24,0.6,0.24c0.23,0,0.46-0.09,0.63-0.27c0.33-0.35,0.32-0.9-0.03-1.24l-2.21-2.11l2.58-2.46 c0.17-0.17,0.27-0.39,0.27-0.63c0-0.24-0.1-0.47-0.27-0.63L29.97,23.01z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon_3.67703699fc5e1e01f38b088133cabade.svg";
export { ForwardRef as ReactComponent };